import numeral from '@tiger/numeral';
import dayjs from 'dayjs';

export const formatMoney = (value: string | number, unit?: string): string => {
    const result = numeral(value).format('0,0.00');

    if (unit) {
        return unit + result;
    }

    return result;
};

/**
 * 日期格式化，默认格式：YYYY-MM-DD
 */
export function formatDate(date: dayjs.ConfigType, format: string = 'YYYY-MM-DD') {
    return date ? dayjs(date).format(format) : '- -';
}
